import { Component } from '@angular/core';
import { HeaderComponent } from './core/header/header.component';
import { MenuComponent } from './core/menu/menu.component';
import { MsalService } from '@azure/msal-angular';

import { Router } from '@angular/router';
import { RoutesDumperService } from './app-routes-dumper.service';

@Component({
    selector: 'otc-root',
    templateUrl: './app.component.html',
    standalone: true,
    imports: [HeaderComponent, MenuComponent]
})
export class AppComponent {
  constructor(private msal: MsalService,
    private router: Router,
    private routesCatalog: RoutesDumperService,) {
    //console.table(this.flatten(this.router.config));   // dev only

    //this.routesCatalog.dumpToConsole(false);
  }

  private flatten(routes: any[], parent = ''): any[] {
    const out: any[] = [];
    for (const r of routes) {
      const path = [parent, r.path].filter(Boolean).join('/');
      out.push({
        path,
        component: (r.component as any)?.name,
        loadChildren: !!r.loadChildren,
        redirectTo: r.redirectTo,
        canActivate: (r.canActivate || []).length
      });

      if (r.children) out.push(...this.flatten(r.children, path));

      // include *already loaded* lazy children
      const loaded = (r as any)._loadedRoutes ?? (r as any)._loadedConfig?.routes;
      if (loaded) out.push(...this.flatten(loaded, path));
    }
    return out;
  }

  ngOnInit(): void {
    const accounts = this.msal.instance.getAllAccounts();

    if (accounts.length === 0) {
      this.msal.loginRedirect();
    } 
  }
}
